import { render, staticRenderFns } from "./SuperMor.vue?vue&type=template&id=87d0bce0&scoped=true"
import script from "./SuperMor.vue?vue&type=script&lang=js"
export * from "./SuperMor.vue?vue&type=script&lang=js"
import style0 from "./SuperMor.vue?vue&type=style&index=0&id=87d0bce0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d0bce0",
  null
  
)

export default component.exports